
import React from 'react';
import { FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import FooterSocial from './FooterSocial';

const FooterBottom = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="mt-12 border-t border-gray-200 pt-8">
      <div className="flex flex-col md:flex-row md:justify-between items-center">
        <div className="mb-4 md:mb-0">
          <span className="text-xl font-semibold text-gray-900">
            Scaloo<span className="text-indigo-600">AI</span>
          </span>
          <p className="mt-2 text-sm text-gray-600">
            &copy; {currentYear} Scaloo AI. Tous droits réservés.
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-4">
          <FooterSocial />
          <Link to="/privacy" className="flex items-center text-sm text-gray-600 hover:text-indigo-600 transition-colors">
            <FileText className="w-4 h-4 mr-1" />
            Règles de confidentialité
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FooterBottom;
